import React, { useState, useEffect } from 'react';
import '../styles/CookieBanner.css';

const CookieBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent || cookieConsent === 'declined') {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-banner">
      <div className="cookie-banner-content">
        <div className="cookie-banner-text">
          <p>
            <strong>Ta strona używa plików cookie</strong>
          </p>
          <p>
            Używamy plików cookie, w tym Google reCAPTCHA, aby zapewnić prawidłowe 
            działanie formularzy i chronić przed spamem. Kontynuując korzystanie ze strony, 
            wyrażasz zgodę na ich użycie.
          </p>
        </div>
        <div className="cookie-banner-buttons">
          <button 
            onClick={handleAccept} 
            className="cookie-btn cookie-btn-accept"
          >
            Akceptuję
          </button>
          <button 
            onClick={handleDecline} 
            className="cookie-btn cookie-btn-decline"
          >
            Odmawiam
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;

